import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { MainWrapper, MainContainer } from "./Main.styled";
import { Header, Tabs } from "./components";
import { Users, Roles, ActivityHistory } from "./pages";
import { UserManagementTabsEnum } from "./enums/userManagementTabs";

// TODO: Set to true when Activity History feature is ready
const SHOW_ACTIVITY_HISTORY = false;

const Main = ({ breadcrumbHelpers }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState(UserManagementTabsEnum.USERS);
  const [selectedCellsCount, setSelectedCellsCount] = useState(0);

  // Mapeo de tabs a rutas URL
  const getTabRoute = (tabIndex) => {
    switch (tabIndex) {
      case UserManagementTabsEnum.USERS:
        return "";
      case UserManagementTabsEnum.ROLES:
        return "roles";
      case UserManagementTabsEnum.ACTIVITY_HISTORY:
        return "activity-history";
      default:
        return "";
    }
  };

  const getTabFromRoute = (pathname) => {
    if (pathname.includes("/roles")) {
      return UserManagementTabsEnum.ROLES;
    } else if (pathname.includes("/activity-history")) {
      return UserManagementTabsEnum.ACTIVITY_HISTORY;
    } else {
      return UserManagementTabsEnum.USERS;
    }
  };

  useEffect(() => {
    const tabFromUrl = getTabFromRoute(location.pathname);
    setSelectedTab(tabFromUrl);
  }, [location.pathname]);

  const handleTabChange = (index) => {
    setSelectedTab(index);
    const newRoute = getTabRoute(index);
    navigate(newRoute, { replace: true });
  };

  return (
    <MainWrapper>
      <Header />
      <Tabs key={selectedTab} onTabChange={handleTabChange} defaultIndex={selectedTab} />
      <MainContainer>
        <Routes>
          <Route
            index
            element={
              <Users
                selectedCellsCount={selectedCellsCount}
                onSelectionChange={setSelectedCellsCount}
                breadcrumbHelpers={breadcrumbHelpers}
              />
            }
          />
          <Route path="roles" element={<Roles breadcrumbHelpers={breadcrumbHelpers} />} />
          {SHOW_ACTIVITY_HISTORY && (
            <Route path="activity-history" element={<ActivityHistory breadcrumbHelpers={breadcrumbHelpers} />} />
          )}
        </Routes>
      </MainContainer>
    </MainWrapper>
  );
};

export default Main;

